<template>
  <v-app style="height: 100%">
    <v-navigation-drawer app v-model="drawer" v-if="!isLogin">
      <v-toolbar :dark="true" class="primary elevation-0">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-list dense nav>
        <v-list-item @click="navigateTo('/')">
          <v-list-item-action>
            <i class="fal fa-home fa-fw" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="menuItem in menu"
          :key="menuItem.id"
          :disabled="!menuItem.enabled"
          @click="navigateTo(menuItem)"
        >
          <v-list-item-action>
            <i
              v-if="menuItem.icon"
              class="fal fa-fw"
              :class="`fa-${menuItem.icon}`"
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ menuItem.name }}
              <sup v-if="menuItem.module == 'external_link'"><i class="fal fa-external-link" aria-hidden="true" style="font-size: 100%" /></sup>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action
            v-if="unreadMessagesCount != 0 && menuItem.module == 'messages'"
          >
            <span class="badge">{{ unreadMessagesCount }}</span>
          </v-list-item-action>

          <v-list-item-action
            v-if="unreadNetworkingMessagesIds.length != 0 && menuItem.module == 'networking'"
          >
            <span class="badge">{{ unreadNetworkingMessagesIds.length }}</span>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      v-if="!isHome && !isLogin"
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="!parent" />
      <v-btn icon v-else @click="toParent">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon v-for="btn in toolbarButtons" :key="btn.path" @click="navigateTo(btn.path)">
        <i :class="'fal fa-' + btn.icon +' fa-fw'"></i>
      </v-btn>

      <settings-icon/>

      <notifications v-if="showNotifications" />
    </v-app-bar>
    <v-main class="classic-main">
      <in-page-messages />
      <transition name="router-view">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-main>
    <v-footer app inset class="pr-2" v-if="isHome && footer.enabled">
      <v-spacer />
      <cookies/>
      <span v-html="footer.content" />
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Notifications from '../components/toolbar/notifications'
import navigateMixin from '../mixins/navigate'
import InPageMessages from '../components/in-page-messages'
import SettingsIcon from '../components/settings/icon'

export default {
  mixins: [navigateMixin],

  components: {
    Notifications,
    InPageMessages,
    SettingsIcon
  },

  data () {
    return {
      drawer: null,
    }
  },

  computed: {
    ...mapGetters({
      toolbarButtons: 'buttons',
      unreadMessagesCount: 'unreadMessagesCount',
      unreadNetworkingMessagesIds: 'unreadNetworkingMessagesIds',
    }),

    ...mapGetters('common', {
      menu: 'rootMenu',
      showNotifications: 'showNotifications'
    }),

    ...mapState({
      user: state => state.auth.user,
      title: state => state.common.title,
      pageTitle: state => state.navbar.title,
      parent: state => state.navbar.parent,
      fullMenu: state => state.common.menu,
      footer: state => state.common.footer,
    }),

    isHome () {
      return this.$route.path == '/'
    },

    isLogin () {
      return this.$route.path == '/login'
    },
  },
}
</script>
